export default function storeAddressList(value) {

    return dispatch => dispatch({
        type: 'SAVE_ADDRESSLIST_FULFILLED',
        payload: value
    });
}


// WEBPACK FOOTER //
// ./src/actions/storeAddressList.js